export default (title: string, details: unknown) => {
    console.debug(`[bus] ${title}${details ? '\n' : ''}`, details);
};
